import { render, staticRenderFns } from "./modalAddCompanyAssets.vue?vue&type=template&id=70a406fa&"
import script from "./modalAddCompanyAssets.vue?vue&type=script&lang=js&"
export * from "./modalAddCompanyAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports